<template>
  <div>
    <div
      class="flex flex-row modal-container"
      :class="{'hidden': !isShown}"
    >
      <div class="log-container">
        <div class="log-header">
          <p class="font-semibold text-3xl">
            Log Activity
          </p>
          <div
            class="self-center"
            @click="$emit('update:isShown', false)"
          >
            <vs-icon
              icon="close"
              color="#FF7F57"
              class="icon-transparent-bg"
            />
          </div>
        </div>
        <div v-if="logData.length">
          <div
            v-for="(item, index) of logData"
            :key="index"
            class="log-item"
          >
            <div class="flex flex-row items-center">
              <div
                v-show="item.type === 'annual'"
                class="w-1/12 mr-3"
              >
                <vs-button
                  color="secondary"
                  type="filled"
                  icon="visibility"
                  size="small"
                  @click="$emit('see', { name: item.type === 'annual'
                                           ? 'SalesPlanDetailAnnual'
                                           : 'SalesPlanDetailMonthly',
                                         params: { id: item.id, period: item.period } })"
                />
              </div>
              <div
                class="flex flex-row"
                :class="[item.type === 'annual' ? 'w-11/12' : 'w-12/12']"
              >
                <div class="log-icon-bg">
                  <img
                    class="w-6"
                    :src="require('../../assets/shipo-icon-log-activity.svg')"
                  >
                </div>
                <div class="flex flex-col justify-center">
                  <p>
                    <span class="font-semibold text-primary">{{ item.created_by || 'Unknown' }}</span>
                    has updated {{ item.type || 'Unknown' }} {{ getLogRevision(item) }}
                  </p>
                  <p class="mt-3 text-sm text-secondary">
                    {{ item.updated_at ? moment(item.updated_at).format('DD-MMM-YYYY HH:mm') : 'Unknown' }}
                  </p>
                </div>
              </div>
            </div>
            <div
              v-if="index !== (logData.length - 1)"
              class="flex flex-row"
            >
              <div class="w-1/12 mr-3" />
              <div class="w-11/12 ml-5 my-5 divider" />
            </div>
          </div>
        </div>
        <div v-else-if="bargeLogData.length">
          <div
            v-for="(item, index) of bargeLogData"
            :key="index"
            class="log-item"
          >
            <div class="flex flex-row items-center">
              <div class="w-full flex flex-row">
                <div class="w-1/12 log-icon-bg">
                  <img
                    :src="require('../../assets/shipo-icon-log-activity.svg')"
                  >
                </div>
                <div class="w-11/12 flex flex-col">
                  <p class="w-full flex flex-row flex-wrap flex-gap">
                    <span class="font-semibold text-primary">{{ item.created_by || 'Unknown' }}</span>
                    &nbsp;
                    <span>has updated</span>
                    &nbsp;
                    <span
                      v-for="(field, fieldIndex) of item.updated_columns"
                      class="text-danger"
                      :key="fieldIndex"
                    >{{ startCase(field) }}{{ fieldIndex !== (item.updated_columns.length - 1) ? ',' : '' }}&nbsp;</span>
                  </p>
                  <p class="mt-2 text-sm text-secondary">
                    {{ item.created_at ? moment(item.created_at).format('DD-MMM-YYYY HH:mm') : 'Unknown' }}
                  </p>
                </div>
              </div>
            </div>
            <div class="flex flex-row">
              <div
                class="w-1/12 ml-5 my-5"
                :class="{'divider-grow': index !== (bargeLogData.length - 1)}"
              />
              <div class="w-10/12 my-5 custom-card">
                <div>
                  <p class="font-semibold text-sm text-grey-001">
                    Reason
                  </p>
                  <vs-divider
                    border-style="dashed"
                    class="my-2"
                  />
                </div>
                <div>
                  <p>{{ item.reason }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <p
          v-else
          class="self-center font-semibold italic text-secondary"
        >
          No History can be shown
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    logData: {
      type: Array,
      default: () => []
    },
    bargeLogData: {
      type: Array,
      default: () => []
    },
    isShown: {
      type: Boolean,
      default: () => false
    }
  },
  methods: {
    getLogRevision(item) {
      if (item.type === 'annual') {
        return item.revision || 'Unknown'
      }
      return item.month
        ? this.moment(item.month, 'M').format('MMMM')
        : 'Unknown'
    }
  }
}
</script>

<style lang="scss" scoped>
img {
  display: block;
}

.modal-container {
  @apply w-full h-full fixed top-0 left-0 justify-end bg-black bg-opacity-50;

  z-index: 1000;
}

.log-container {
  @apply w-1/3 min-h-screen flex flex-col overflow-auto;

  background-color: #F1F1FD;
}

.log-header {
  @apply p-5 mb-5 flex flex-row justify-between rounded-b-2xl bg-white;
}

.log-item {
  @apply px-12 flex flex-col;
}

.log-icon-bg {
  @apply p-2 mr-3 flex flex-col justify-center rounded-lg bg-white;

  max-height: 35px;
}

.icon-transparent-bg {
  @apply p-1 flex flex-col justify-center rounded-lg cursor-pointer;

  background-color: rgba(255, 127, 87, 0.2);
}

.divider {
  @apply h-10;

  border-left: solid 1px #CDC6E1;
}

.divider-grow {
  border-left: solid 1px #CDC6E1;
}

.custom-card {
  @apply p-3 flex flex-col rounded-xl bg-white;
}

.flex-gap {
  grid-row-gap: 2px;
}
</style>
